import React, { Component } from 'react';
import * as ajax from './../../ajax.js';
import * as lang from './../../lang.js';

import PopUpWindow from './../../components/PopUpWindow';
import { Container, Row, Col, Button } from 'react-bootstrap';

import SzabadsagokComboBoxInsertField from './../../componentsSpecial/SzabadsagokComboBoxInsertField';
import DateInsertField from './../../components/DateInsertFieldSzabadsag';
import TimeInsertField from './../../components/TimeInsertField';
import TextAreaInsertField from './../../components/TextAreaInsertField';


class SzabadsagokInsert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            szabadsagok_dolgozoId: ''
            , szabadsagok_nap: ''
            , szabadsagok_nap_ig: ''
            , szabadsagok_idoTol: ''
            , szabadsagok_idoIg: ''
            , szabadsagok_megjegyzes: ''
            , szabadsagok_tipus: ''


        }

        this.references = [];
        this.references['szabadsagok_dolgozoId'] = React.createRef();
        this.references['szabadsagok_nap'] = React.createRef();
        this.references['szabadsagok_nap_ig'] = React.createRef();
        this.references['szabadsagok_idoTol'] = React.createRef();
        this.references['szabadsagok_idoIg'] = React.createRef();
        this.references['szabadsagok_megjegyzes'] = React.createRef();
        this.references['szabadsagok_tipus'] = React.createRef();

        this.validators = [];
        this.validators['szabadsagok_dolgozoId'] = {fieldName: 'szabadsagok_dolgozoId', dataType: 'INT', value: this.state.szabadsagok_dolgozoId, mandatory: true, min: null, max: null};
        this.validators['szabadsagok_nap'] = {fieldName: 'szabadsagok_nap', dataType: 'DATE', value: this.state.szabadsagok_nap, mandatory: true, min: null, max: null};
        this.validators['szabadsagok_nap_ig'] = {fieldName: 'szabadsagok_nap_ig', dataType: 'DATE', value: this.state.szabadsagok_nap_ig, mandatory: true, min: null, max: null};
        this.validators['szabadsagok_idoTol'] = {fieldName: 'szabadsagok_idoTol', dataType: 'TIME', value: this.state.szabadsagok_idoTol, mandatory: false, min: null, max: null};
        this.validators['szabadsagok_idoIg'] = {fieldName: 'szabadsagok_idoIg', dataType: 'TIME', value: this.state.szabadsagok_idoIg, mandatory: false, min: null, max: null};
        this.validators['szabadsagok_megjegyzes'] = {fieldName: 'szabadsagok_megjegyzes', dataType: 'VARCHAR', value: this.state.szabadsagok_megjegyzes, mandatory: false, min: null, max: null};
        this.validators['szabadsagok_tipus'] = {fieldName: 'szabadsagok_tipus', dataType: 'VARCHAR', value: this.state.szabadsagok_tipus, mandatory: true, min: null, max: null};

        this.error = false;
        this.msg = "";

    }

    componentDidMount() {
        this.reset();
        if (typeof this.props.szabadsag_datum != 'undefined') {
            var selectedDate = this.props.szabadsag_datum.toLocaleDateString();
            var formattedDate = this.formatDate(selectedDate);
            this.setState({szabadsagok_nap: formattedDate});
            this.setState({szabadsagok_nap_ig: formattedDate});
        }
    }
    formatDate = function (dateString) {
        if (typeof dateString == 'undefined') {
            return '';
        }
        if (typeof dateString == null) {
            return '';
        }
        if (typeof dateString == '') {
            return '';
        }
        var splited = dateString.split('.');
        var year = splited[0].trim();
        var month = splited[1].trim();
        var days = splited[2].trim();

        return year + "-" + month + "-" + days;



    }

    setFocusedComponent = function () {
        try {
            for (var i = 0; i < Object.keys(this.references).length; i++) {
                let first = Object.keys(this.references)[i];

                if (this.references[first].current != null && typeof this.references[first].current.focus != 'undefined') {
                    this.references[first].current.focus();
                    return false;
                }
            }
        } catch (e) {
            console.log("can not set focus on first component");
        }
    }

    reset = function () {
        this.setFocusedComponent();
        this.setState({
            szabadsagok_dolgozoId: ''
            , szabadsagok_nap: ''
            , szabadsagok_nap_ig: ''
            , szabadsagok_idoTol: ''
            , szabadsagok_idoIg: ''
            , szabadsagok_megjegyzes: ''
            , szabadsagok_tipus: ''

        });
    }

    setBack = function (id, value) {
        if (id === 'szabadsagok_nap') {
            this.state['szabadsagok_nap_ig'] = value;
        }
        this.setState({[id]: value});
    }

    getForm = function () {
        return <Container>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_dolgozoId')}</Col>
                <Col style={{textAlign: 'right'}}>
                <SzabadsagokComboBoxInsertField 
                    id={'szabadsagok_dolgozoId'} 
                    value={this.state.szabadsagok_dolgozoId}  
                    setBack={this.setBack.bind(this)}
                    dataSourceUrl={'modules/Szabadsagok/dolgozoIdFormComboInsertData.php'}
                    reference={this.references['szabadsagok_dolgozoId']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_tipus')}</Col>
                <Col style={{textAlign: 'right'}}>
                <select
                    id="szabadsagok_tipus"
                    value={this.state.szabadsagok_tipus || ''}
                    onChange={(e) => this.setBack('szabadsagok_tipus', e.target.value)}
                    ref={this.references['szabadsagok_tipus']}
                    style={{minWidth: 196}}
                    required
                    >
                    <option value="" disabled>Kérem válasszon</option>
                    <option value="SZABADSAG">Szabadság</option>
                    <option value="NEM_BEOSZTHATO">Nem beosztható</option>
                </select>
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_nap')}</Col>
                <Col style={{textAlign: 'right', display: 'contents'}}>
                <DateInsertField 
                    id={'szabadsagok_nap'} 
                    value={this.state.szabadsagok_nap}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szabadsagok_nap']}
                    editable={true}
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_nap_ig')}</Col>
                <Col style={{textAlign: 'right', display: 'contents'}}>
                <DateInsertField 
                    id={'szabadsagok_nap_ig'} 
                    value={this.state.szabadsagok_nap_ig}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szabadsagok_nap_ig']}
                    editable={true}   
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_idoTol')}</Col>
                <Col style={{textAlign: 'right'}}><TimeInsertField 
                    id={'szabadsagok_idoTol'} 
                    value={this.state.szabadsagok_idoTol}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szabadsagok_idoTol']}
                    editable={true}   
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_idoIg')}</Col>
                <Col style={{textAlign: 'right'}}><TimeInsertField 
                    id={'szabadsagok_idoIg'} 
                    value={this.state.szabadsagok_idoIg}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szabadsagok_idoIg']}
                    editable={true}   
                    theme={this.props.theme}
                    />
                </Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'left'}}>{lang.getTitleBold('szabadsagok_megjegyzes')}</Col>
            </Row>
            <Row>
                <Col style={{textAlign: 'right'}}>
                <TextAreaInsertField 
                    id={'szabadsagok_megjegyzes'} 
                    value={this.state.szabadsagok_megjegyzes}  
                    setBack={this.setBack.bind(this)}
                    reference={this.references['szabadsagok_megjegyzes']}
                    editable={true}   
                    theme={this.props.theme}
                    style={{minWidth: '100%'}}
                    />
                </Col>
            </Row>
        </Container>
    }

    closeForm = function () {
        this.reset();
        this.props.closeForm();

    }

    transactionSuccess = function () {
        this.error = false;
        this.msg = lang.getTitleBold('transaction_success');
        this.setState({});
    }

    transactionFail = function (errorStringConstant) {
        this.error = true;
        this.msg = lang.getTitleBold(errorStringConstant);
        this.setState({});
    }

    concatAdditionalParams = function () {
        var stateClone = JSON.parse(JSON.stringify(this.state));
        if (typeof this.props.additionalParams == 'undefined') {
            return this.state;
        }

        if (this.props.additionalParams == null) {
            return this.state;
        }

        var additionalParams = this.props.additionalParams;
        for (var i = 0; i < additionalParams.length; i++) {
            var additionalParam = additionalParams[i];
            for (const property in additionalParam) {
                stateClone[property] = additionalParam[property];
            }
        }
        return stateClone;
    }

    insert = function (e) {
        var validator = ajax.Validator();
        var validForm = validator.formValidator(this.references, this.validators, this.state);
        if (validForm == false) {
            return false;
        }

        var method = e.target.id;
        var self = this;

        var params = this.concatAdditionalParams();

        try {
            const url = ajax.getUrlBase() + "modules/Szabadsagok/szabadsagokFormInsert.php";

            return fetch(url, {
                method: "POST",
                headers: new Headers({"Content-Type": "application/json"}),
                body: JSON.stringify(params)
            }).then(response => {
                if (response.ok) {
                    return response.json().then(response => {
                        if (response.success) {
                            self.transactionSuccess();
                            if (method == 'save') {
                                self.closeForm();
                            }
                            if (method == 'save_new') {
                                self.reset();
                            }
                        } else {
                            self.transactionFail(response.fail);
                        }

                    }).catch(function (jsonError) {
                        self.state.defaultUpdateBlocked = false;
                        if (null == jsonError) {
                            self.transactionFail('Fetch JSON error');
                            console.error("Fetch JSON error:");
                        } else {
                            self.transactionFail("Fetch JSON error:" + String(jsonError));
                            console.error("Fetch JSON error:" + String(jsonError));
                        }
                    });
                } else {
                    self.state.defaultUpdateBlocked = false;
                    self.transactionFail("HTTP status error:", response.statusText);
                    console.error("HTTP status error:", response.statusText);
                }
            }).catch(function (error) {
                self.state.defaultUpdateBlocked = false;
                self.transactionFail("Fetch error:", error);
                console.error("Fetch error:", error);
                if (null == error) {
                    self.transactionFail("Fetch error:");
                    console.error("Fetch error:");
                } else {
                    self.transactionFail("Fetch error:" + String(error));
                    console.error("Fetch error:" + String(error));
                }
            });
        } catch (ex) {
            self.state.defaultUpdateBlocked = false;
            self.transactionFail("Fetch exception:", String(ex));
            console.error("Fetch exception:", String(ex));
        }
    }

    render() {
        var form = this.getForm();
        var className = (this.props.theme == "true") ? "Dark" : "Light";
        return (<PopUpWindow theme={this.props.theme} style={{maxHeight: 600}}>
            <div className={'popupWrapper' + className} id="SzabadsagokInsert">
                <div  className={"popupHeader" + className} >
                    <Row>
                        <Col></Col>
                        <Col style={{textAlign: 'center'}}>{lang.getTitleBold('SzabadsagokInsert')}</Col>
                        <Col style={{textAlign: 'right'}}>
                        <Button className={'btn-sm'} variant="danger" onClick={this.closeForm.bind(this)}>{lang.getTitle('close')}</Button>
                        </Col>
                    </Row>
                </div>
                <div  className={"popupBody" + className} >{form}</div>
                <div  className={"popupFooter" + className} >
                    <Row>
                        <Col>
                        <div style={{whiteSpace: 'break-spaces'}}>
                            {this.msg} 
                        </div>
        
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                        <Button className={'btn-sm'} id={'save'} onClick={this.insert.bind(this)} variant="success" style={{marginTop: '5px'}}>{lang.getTitle('save')}</Button>&nbsp;&nbsp;&nbsp;      
                        <Button className={'btn-sm'} id={'save_new'} onClick={this.insert.bind(this)} variant="info" style={{marginTop: '5px'}}>{lang.getTitle('new')}</Button>      
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{minHeight: '10px'}}>
        
                        </Col>
                    </Row>
        
                </div>
            </div>
        </PopUpWindow>);
    }
}

export default SzabadsagokInsert;

